const timesheetEmployeeSlugMap = Object.freeze({
  'Marcus Gunn': 'marcus-gunn',
  'Alfred Miller': 'alfred-miller',
  'Benjamin Brandt': 'benjamin-brandt',
  'Brandon Armstrong': 'brandon-armstrong',
  'Brandon Lea': 'brandon-lea',
  'Jasmine Barnes': 'jasmine-barnes',
  'Kevin Louie': 'kevin-louie',
  'Bradford Beacham': 'bradford-beacham',
  'Phillip Hetzler': 'phillip-hetzler',
  'Andrea Fields': 'andrea-fields',
  'Arthur Greenberg': 'arthur-greenberg',
  'Matt G': 'matt-g',
});

const chickFilAAttendanceValidationTargets = Object.freeze({
  'marcus-gunn': 81,
  'alfred-miller': 82,
  'benjamin-brandt': 83,
  'brandon-armstrong': 81,
  'jasmine-barnes': 71,
  'kevin-louie': 73,
  'bradford-beacham': 51,
  'phillip-hetzler': 55,
  'brandon-lea': 17,
  'andrea-fields': 8,
  'arthur-greenberg': 8,
  'matt-g': 0,
});

const chickFilAAttendanceOverrides = Object.freeze([
  Object.freeze({
    employeeSlug: 'brandon-lea',
    attendedEvents: 17,
    reason: 'Historical estimate based on approximately one attendance for every four eligible Chick-fil-A Fridays.',
  }),
  Object.freeze({
    employeeSlug: 'matt-g',
    attendedEvents: 0,
    reason: 'Known historical attendance is zero despite qualifying remote work activity.',
  }),
]);

const chickFilAEmploymentOverrides = Object.freeze([
  Object.freeze({ employeeSlug: 'bradford-beacham', deriveEndFromTimesheet: true }),
  Object.freeze({ employeeSlug: 'andrea-fields', deriveStartFromTimesheet: true, endDate: null }),
  Object.freeze({ employeeSlug: 'arthur-greenberg', deriveStartFromTimesheet: true, endDate: null }),
]);

const chickFilAFridayConfig = Object.freeze({
  slug: 'chick-fil-a-friday',
  title: 'Chick-fil-A Friday',
  shortTitle: 'Chick-fil-A Friday',
  startedOn: '2024-09-20',
  latestConfirmedDate: '2026-09-11',
  venue: Object.freeze({ name: 'Chick-fil-A' }),
  qualifyingCustomers: Object.freeze(['Raytheon', 'Nightwing', 'Booz Allen Hamilton']),
  tags: Object.freeze(['tradition', 'local', 'food', 'office', 'weekly', 'crew']),
  rankingMinimumEligibleEvents: 10,
  expectedEventCount: 92,
  nextMilestone: 100,
});

const chickFilAFridayMilestoneCounts = Object.freeze([1, 25, 50, 75, 100]);

const buildChickFilAFridayMilestones = (config = chickFilAFridayConfig) => (
  [...new Set([...chickFilAFridayMilestoneCounts, config.expectedEventCount])]
    .sort((a, b) => a - b)
    .map((count) => {
      if (count === 1) {
        return Object.freeze({
          count,
          label: 'First Chick-fil-A Friday',
          date: config.startedOn,
        });
      }

      const milestone = {
        count,
        label: `${count} Chick-fil-A Fridays`,
      };

      if (count === config.expectedEventCount) milestone.date = config.latestConfirmedDate;
      if (count === config.nextMilestone && count > config.expectedEventCount) {
        milestone.description = 'Next milestone';
      }

      return Object.freeze(milestone);
    })
);

module.exports = {
  buildChickFilAFridayMilestones,
  chickFilAAttendanceOverrides,
  chickFilAAttendanceValidationTargets,
  chickFilAEmploymentOverrides,
  chickFilAFridayConfig,
  timesheetEmployeeSlugMap,
};
